<template>
  <div>
    <div
      class="parent"
      :style="style"
      :class="[!showDetails ? 'parent-2' : '']"
    >
      <v-card @click="showRegister">
        <v-card-title class="info-title">
          <div class="text-center">
            {{ tarh.Title }}
          </div>
        </v-card-title>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  props: ["tarh", "index", "showDetails"],
  methods: {
    /**
     * user click on tarh
     */
    showRegister() {
      if (!this.showDetails) {
        this.$emit("clicked", this.index);
      }
    },
  },
  computed: {
    style() {
      var res = "";
      if (this.showDetails) {
        res += "position: fixed;";
        if (this.$store.getters.isMobile) {
          res += "width: 100%";
        } else {
          res += "width: calc(100% - 300px)";
        }
      } else {
        res+='margin-top: 10px'
      }
      return res;
    },
  },
};
</script>
<style scoped>
.v-card__title {
  border-radius: 15px !important;
}
</style>


